import type {
  partOtherProcess,
  partOtherProcessRow,
} from "@/api/breakdownService";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PartOtherProcessDataEdit from "./PartOtherProcessDataEdit";

interface PartOtherProcessTableProps {
  rows?: Array<partOtherProcessRow>;
  title: string;
  setFormData: React.Dispatch<React.SetStateAction<partOtherProcess>>;
  isEditingPartProcess: boolean;
  type: "OEM" | "Spare";
  rowsTotal?: Array<{ id: number; total_price: number }>;
  setFlaggedReason: React.Dispatch<React.SetStateAction<Set<string>>>;
}

const PartOtherProcessTable = ({
  rows,
  title,
  setFormData,
  isEditingPartProcess,
  type,
  setFlaggedReason,
}: PartOtherProcessTableProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid #e0e0e0",
        borderRadius: 1,
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "500px",
          minHeight: "300px",
          overflow: "auto",
          position: "relative",
          width: "100%",
          backgroundColor: "#f3f3f3ff",
        }}
      >
        <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: "50%",
                  textAlign: "left",
                  borderRight: "1px solid #e0e0e0",
                }}
              >
                {title}
              </TableCell>
              <TableCell
                sx={{
                  width: "30%",
                  textAlign: "left",
                  borderRight: "1px solid #e0e0e0",
                }}
              >
                Detail
              </TableCell>
              <TableCell
                sx={{
                  width: "20%",
                  textAlign: "right",
                  borderRight: "1px solid #e0e0e0",
                }}
              >
                Price (THB)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isEditingPartProcess ? (
              rows &&
              rows.length > 0 &&
              rows
                .sort((a, b) => a.id - b.id)
                .map((row) => (
                  <PartOtherProcessDataEdit
                    key={row.id}
                    row={row}
                    setFormData={setFormData}
                    type={type}
                    setFlaggedReason={setFlaggedReason}
                  />
                ))
            ) : rows && rows.length > 0 ? (
              rows
                .sort((a, b) => a.id - b.id)
                .map((row) => (
                  <TableRow key={row.id} sx={{ backgroundColor: "#fff" }}>
                    <TableCell
                      sx={{
                        width: "50%",
                        textAlign: "left",
                        borderRight: "1px solid #e0e0e0",
                      }}
                    >
                      {row.process_name}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "30%",
                        textAlign: "left",
                        borderRight: "1px solid #e0e0e0",
                      }}
                    >
                      {row.detail}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "20%",
                        textAlign: "right",
                        borderRight: "1px solid #e0e0e0",
                      }}
                    >
                      {Number(row.price ?? 0).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow sx={{ height: "200px" }}>
                <TableCell
                  colSpan={3}
                  sx={{
                    textAlign: "center",
                    padding: 4,
                  }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PartOtherProcessTable;
